import { DialogFooter } from "@blueprintjs/core";
import { useNavigate } from "react-router";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogInner,
  DialogTitle,
} from "@/components/ui/dialog";
import { DetailQueryMeeting } from "@/types/meetings";

interface RescheduleBalanceNotEnoughErrModalProps {
  visible: boolean;
  onCancel: () => void;
  isBuyCreditRedirect: boolean;
  meeting?: DetailQueryMeeting | null;
}

export function RescheduleBalanceNotEnoughErrModal({
  visible = false,
  onCancel,
  isBuyCreditRedirect = false,
  meeting = null,
}: RescheduleBalanceNotEnoughErrModalProps) {
  const navigate = useNavigate();

  const handleBuyCredits = () => {
    navigate("/buy");
  };

  return (
    <Dialog open={visible} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="w-[450px] max-w-md p-0">
        <DialogHeader className="flex space-y-4 text-center ">
          <DialogTitle>Unable to reschedule</DialogTitle>
        </DialogHeader>
        <DialogInner>
          <div>
            Free rescheduling closed {meeting?.cancellationWindowHours} hours
            before your session. You need credits to reschedule now, but don't
            have enough available.
          </div>
          <div className="mt-2">
            {isBuyCreditRedirect
              ? "Buy more credits to reschedule."
              : "Contact your workspace admin for more credits."}
          </div>
        </DialogInner>
        <DialogFooter>
          {isBuyCreditRedirect && (
            <Button onClick={handleBuyCredits} intent="primary">
              Buy More Credits
            </Button>
          )}

          <Button
            onClick={onCancel}
            intent={isBuyCreditRedirect ? "secondary" : "primary"}
          >
            Dismiss
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
